import type {
  ChatProductItem,
  ChatProductItemMinimal,
} from "schemas/generated/chatMessage";

import React from "react";

import { Image } from "lucide-react";

export const ProductToken: React.FC<{
  data: ChatProductItem | ChatProductItemMinimal;
}> = ({ data }) => {
  let featuredMediaUrl = data.featuredMedia?.url;
  const media = (data as ChatProductItem).media;
  if (media?.[0]?.type === "image") {
    featuredMediaUrl = media[0].url;
  }

  return (
    <span className="inline-flex items-center align-middle max-w-full p-1 border-[0.5px] border-border bg-sheet rounded-md">
      {featuredMediaUrl ? (
        <img
          src={featuredMediaUrl}
          alt={data.title}
          className="w-5 h-5 object-cover rounded-sm inline align-baseline mr-1 border border-border"
        />
      ) : (
        <Image className="w-5 h-5 object-cover text-placeholder rounded-sm inline align-baseline mr-1 border border-border " />
      )}
      <span className="font-medium text-default truncate">{data.title}</span>
    </span>
  );
};
